// Constants
import { EngagementTelemetryConstants } from "@ms/uno-constants/lib/local/EngagementTelemetryConstants";
import { SupportedPersonalTaskGroupingOptions } from "@ms/uno-constants/lib/local/GroupingConstants";
import { DefaultViewTypeForPersonalViews, ViewType } from "@ms/uno-constants/lib/local/RoutingConstants";
import { ViewName } from "@ms/uno-constants/lib/local/ViewConstants";
import { DefaultMyTasksViewPivotType } from "@ms/uno-constants/lib/local/ViewPivots";
import { ViewActionBar } from "@ms/planner-presentational-controls/lib/local/viewActionBar/ViewActionBar";
// Hooks
import { useActionCreators } from "@ms/planner-container-controls/lib/local/hooks/useActionCreators";
import { useConfigProvider } from "@ms/planner-container-controls/lib/local/hooks/useConfigProvider";
import { useStores } from "@ms/planner-container-controls/lib/local/hooks/useStores";
import { useInteractionTracker } from "@ms/planner-presentational-controls/lib/local/hooks/useInteractionTracker";
// Stores
import { Store } from "@ms/planner-stores/lib/local/stores/Store";
// Action Creators
import { ActionCreator } from "@ms/planner-actioncreators/lib/local/actioncreators/ActionCreator";
// Utilities
import { useLoggers } from "@ms/planner-presentational-controls/lib/local/utilities/hooks/useLoggers";
import { extractMyTasksRoutingDetailsFromSubRoute } from "@ms/uno-routing/lib/local/utilities/RouteUtilities";
import { TraceLevel } from "@ms/uno-telemetry/lib/local/events/Trace.event";
import * as React from "react";
const componentName = ViewName.MyTasksPage;
/**
 * Container component for My Tasks view action bar
 */ export const ViewActionBarContainer = ()=>{
    const [viewStore, routeStore] = useStores([
        Store.View,
        Store.Route
    ]);
    const [viewTransformsActionCreator] = useActionCreators([
        ActionCreator.ViewTransforms
    ]);
    const { traceLogger, engagementLogger } = useLoggers();
    const { startInteraction } = useInteractionTracker();
    const configProvider = useConfigProvider();
    // Get current pivot from route
    const subRouteType = routeStore.getCurrentSubRouteType();
    const myTasksRoutingDetails = extractMyTasksRoutingDetailsFromSubRoute(routeStore.getCurrentSubRoute(), subRouteType);
    // Get current pivot type and view type
    const currentPivot = myTasksRoutingDetails?.pivotType ?? DefaultMyTasksViewPivotType;
    const currentViewType = myTasksRoutingDetails?.viewType || DefaultViewTypeForPersonalViews;
    const isNewMyTasksExperience = configProvider().flights.EnableNewMyTasksExperience;
    const isGridView = currentViewType === ViewType.Grid;
    const viewId = {
        name: ViewName.MyTasksPage,
        partitionKey: currentPivot
    };
    /**
     * In the new experience (flight ON + list view), GroupBy lives in ViewNavigationBarContainer instead.
     * In all other cases (legacy board view, or flight off), show GroupBy here (unless Grid view).
     */ let groupByDropdownProps;
    const isInNewExperience = isNewMyTasksExperience && currentViewType === ViewType.List;
    if (!isInNewExperience && !isGridView) {
        groupByDropdownProps = {
            taskGroupingOptions: SupportedPersonalTaskGroupingOptions,
            currentTaskGrouping: viewStore.getCurrentTaskGroupingState(viewId),
            onGroupByChange: (taskGroupState)=>{
                const personalTaskGroupingOptions = SupportedPersonalTaskGroupingOptions;
                if (personalTaskGroupingOptions.includes(taskGroupState)) {
                    if (taskGroupState !== viewStore.getCurrentTaskGroupingState(viewId)) {
                        engagementLogger.logEngagement(componentName, EngagementTelemetryConstants.MyTasksChangeGrouping, {
                            grouping: taskGroupState,
                            isNewExperience: String(isNewMyTasksExperience)
                        });
                    }
                    startInteraction({
                        name: "GroupBy",
                        key: taskGroupState
                    }, viewId, "tasksBoard");
                    viewTransformsActionCreator.setTaskGroupingState(viewId, taskGroupState);
                } else {
                    traceLogger.logTrace(0x1e15159b /* tag_4frw1 */ , TraceLevel.Warning, "Group by attempted with unsupported option");
                }
            }
        };
    }
    return /*#__PURE__*/ React.createElement(ViewActionBar, {
        groupByDropdownProps: groupByDropdownProps,
        groupByButtonTestId: "my-tasks-view-action-bar-group-by-button"
    });
};
